/**
 * InfoTip — the Combine & Filter page's ⓘ: the design system `Tooltip` over a
 * small "i" glyph. One copy for the page, its Filters card and its funnel
 * (PR #962 follow-up F4 gave the funnel its first one; the page and the
 * Filters card each had their own identical copy until then).
 */
import { Tooltip } from "@nu-assist/ui";

export function InfoTip({ content }: { content: string }) {
  // `Tooltip` wraps its child in its OWN `tabIndex={0}` span (see its own
  // docblock) — a second one here would double the tab stop. `role="img"` +
  // `aria-label` give this glyph the accessible name that trigger needs,
  // mirroring `CriteriaBox.tsx`'s own "About rerunning" tip.
  return (
    <Tooltip content={content}>
      <span
        role="img"
        aria-label={content}
        className="inline-flex h-4 w-4 shrink-0 cursor-help items-center justify-center rounded-full border border-border text-micro text-text-secondary"
      >
        i
      </span>
    </Tooltip>
  );
}
